import { Button, Flex, Stack, Text } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import theme from 'theme'

import type { PropsWithChildren } from 'react'

type TableListRowProps = {
  label: string
  value: string
  onClick: () => void
}

const TableList = ({ children }: PropsWithChildren) => {
  return (
    <Flex direction="column" bgColor={theme.colors.white}>
      {children}
    </Flex>
  )
}

export const TableListRow = ({ label, value, onClick }: TableListRowProps) => {
  return (
    <Button
      h="unset"
      py={0}
      px={3}
      borderRadius={0}
      onClick={onClick}
      bgColor={theme.colors.white}
      borderBottomWidth={1}
      _first={{ borderTopRadius: 'base' }}
      _last={{ borderBottomRadius: 'base', borderBottomWidth: 0 }}
    >
      <Flex w="100%" px={3} py={4} justifyContent="space-between" gap={3} alignItems="center">
        <Text textStyle="body1bold">{label}</Text>
        <Stack direction="row" alignItems="center" spacing={3} overflow="auto">
          <Text textStyle="body1" textAlign="end" whiteSpace="normal" overflow="auto">
            {value}
          </Text>
          <FontAwesomeIcon icon={['far', 'chevron-right']} size="sm" color={theme.baseColors.text.disabled} />
        </Stack>
      </Flex>
    </Button>
  )
}

export default TableList
